<script setup lang="ts">
interface ArchivePaginationProps {
  isFetchingNextPage?: boolean
  label: string
  count?: number
  currentCount?: number
}

withDefaults(defineProps<ArchivePaginationProps>(), {
  count: 0,
  currentCount: 0,
})

defineEmits(['fetchNextPage'])
</script>

<template>
  <div class="container pt-25 text-center flex">
    <div class="m-auto space-y-2.5">
      <Text as="div" class="typo-sans-1 uppercase" :text="$t('x_of_y', { current: currentCount, count, label: $t(label, count) })" />
      <ButtonLink :disabled="isFetchingNextPage" :title="isFetchingNextPage ? $t('loading') : $t('load_more')" @click="$emit('fetchNextPage')" />
    </div>
  </div>
</template>
